import { Suspense } from 'react';
import { createCrumbHandle } from '../../utilities/auth';
import { PageLoading } from '../../core-components/theme/components/Screen';
import { ANALYTICS_RULES, access, param } from '../../access';
import BatchConfigListing from '../../pages/BatchConfig/components/BatchConfigListing';
import CreateEditBatchConfigPage from '../../pages/BatchConfig/components/CreateEditBatchPage';


const batchConfigRoute = [
  {
    path: '/batch-config/:assetId',
    handle: createCrumbHandle('Batch Config'),
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<PageLoading />}>
            <BatchConfigListing />
          </Suspense>
        ),
        handle: access(ANALYTICS_RULES.batches, param('assetId')),
      },
      {
        path: "createEditBatchConfig/:batchConfigurationId?",
        index: true,
        element: (
          <Suspense fallback={<PageLoading />}>
            <CreateEditBatchConfigPage />
          </Suspense>
        ),
        handle: { ...createCrumbHandle('Create Batch Config'), ...access(ANALYTICS_RULES.manageBatches, param('assetId')) },
      }
    ]
  },
];

export default batchConfigRoute;
